import { useCallback } from "react";

import { useFireAnalyticsEvents } from "@/components/fastshift/analytics";
import {
    ActionKey,
    ActionSubjectKey,
    ActionSubjectIdKey
} from "@/components/fastshift/analytics/constants";

import { TAB_KEYS } from "../constants";

import { useResourcesPageAnalyticsData } from "./use-resources-page-analytics-data";

export const useResourcesPageUIAnalytics = (isDomainScoped: boolean) => {
    const { sourceKey, identityAttrs } =
        useResourcesPageAnalyticsData(isDomainScoped);
    const { fireUIEvent } = useFireAnalyticsEvents(identityAttrs);

    const sendResourceFilterClickUIEvent = useCallback(
        (selectedFilter: TAB_KEYS) => {
            fireUIEvent({
                action: ActionKey.CLICKED,
                actionSubject: ActionSubjectKey.BUTTON,
                actionSubjectId: ActionSubjectIdKey.RESOURCE_FILTER,
                source: sourceKey,
                attributes: {
                    selectedFilter,
                    ...identityAttrs
                }
            });
        },
        [fireUIEvent, sourceKey, identityAttrs]
    );

    const sendResourceLinkClickUIEvent = useCallback(
        (resourceSubject: string, resourceCategory: TAB_KEYS) => {
            fireUIEvent({
                action: ActionKey.CLICKED,
                actionSubject: ActionSubjectKey.LINK,
                actionSubjectId: ActionSubjectIdKey.RESOURCE_LINK,
                source: sourceKey,
                attributes: {
                    resourceSubject,
                    resourceType: resourceCategory,
                    ...identityAttrs
                }
            });
        },
        [fireUIEvent, sourceKey, identityAttrs]
    );

    const sendUsefulLinkClickUIEvent = useCallback(
        (linkSubject: string) => {
            fireUIEvent({
                action: ActionKey.CLICKED,
                actionSubject: ActionSubjectKey.LINK,
                actionSubjectId: ActionSubjectIdKey.USEFUL_LINK,
                source: sourceKey,
                attributes: {
                    linkSubject,
                    ...identityAttrs
                }
            });
        },
        [fireUIEvent, sourceKey, identityAttrs]
    );

    return {
        sendResourceFilterClickUIEvent,
        sendResourceLinkClickUIEvent,
        sendUsefulLinkClickUIEvent
    };
};
